/**
 * HeroCentered Section
 * Центрированный hero: текст по центру, изображение сверху или снизу
 */
import { Text, Button, Image, Container } from '../components';

const heightClasses = {
  auto: '',
  small: 'min-h-[450px] md:min-h-[500px]',
  medium: 'min-h-[550px] md:min-h-[600px]',
  large: 'min-h-[650px] md:min-h-[700px]',
};

const imageHeightClasses = {
  small: 'h-[200px] md:h-[250px]',
  medium: 'h-[280px] md:h-[350px]',
  large: 'h-[350px] md:h-[450px]',
};

export default function HeroCenteredSection({ data, styles }) {
  const imagePosition = data?.imagePosition || 'bottom';
  const height = data?.height || 'auto';
  const imageHeight = data?.imageHeight || 'medium';
  const buttons = data?.buttons || [];
  const hasImage = !!data?.image;

  const isImageTop = imagePosition === 'top';

  const renderImage = () => {
    if (!hasImage) return null;

    return (
      <div className={`relative w-full max-w-4xl mx-auto ${imageHeightClasses[imageHeight]} rounded-lg md:rounded-xl overflow-hidden`}>
        <Image
          src={data.image}
          alt={data?.title?.text || data?.title || ''}
          className="absolute inset-0 w-full h-full"
          fit="cover"
          loading="eager"
        />
      </div>
    );
  };

  const renderContent = () => (
    <div className="text-center max-w-3xl mx-auto">
      {/* Бейдж/лейбл */}
      {(data?.badge?.text || data?.badge) && (
        <div className="mb-4 md:mb-6">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-700">
            <Text
              as="span"
              data={typeof data.badge === 'object' ? data.badge : { text: data.badge }}
              defaults={{ size: 'sm', weight: 'medium', color: 'inherit' }}
            />
          </span>
        </div>
      )}

      {/* Заголовок */}
      <Text
        as="h1"
        data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
        defaults={{ size: '5xl', weight: 'bold', color: 'inherit' }}
        className="mb-4 md:mb-6"
      />

      {/* Подзаголовок */}
      {(data?.subtitle?.text || data?.subtitle) && (
        <Text
          as="p"
          data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
          defaults={{ size: 'lg', weight: 'normal', color: 'secondary' }}
          className="mb-6 md:mb-8"
        />
      )}

      {buttons.length > 0 && (
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
          {buttons.map((button, index) => {
            const textData = typeof button.text === 'object' ? button.text : { text: button.text || '' };
            return (
              <Button
                key={button.id || index}
                href={button.link || '#'}
                variant={button.variant || 'primary'}
                size="lg"
              >
                <Text
                  as="span"
                  data={textData}
                  defaults={{ size: 'base', weight: 'medium', color: 'inherit' }}
                />
              </Button>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <section
      className={`relative ${heightClasses[height] || ''} flex flex-col justify-center`}
      style={{
        paddingTop: styles?.paddingTop ?? 64,
        paddingBottom: styles?.paddingBottom ?? 64,
        backgroundColor: styles?.backgroundColor || '#ffffff'
      }}
    >
      <Container>
        <div className="space-y-8 md:space-y-12">
          {isImageTop && renderImage()}
          {renderContent()}
          {!isImageTop && renderImage()}
        </div>
      </Container>
    </section>
  );
}
